import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { confirmData } from '../components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-session-idle',
  templateUrl: './session-idle.component.html',
  styleUrls: ['./session-idle.component.css']
})
export class SessionIdleComponent implements OnInit {
  
  message?:string;
  time=5;
  timer:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: confirmData,private dialogRef: MatDialogRef<SessionIdleComponent>) { 
    this.timer=setInterval(() => {
      this.time--;
      this.message="you are going to logout";
      if(this.time==0){
        this.dialogRef.close(true);
      }
    },1000)
  }
  
  confirm(event: any) {
    this.time=5;
    clearInterval(this.timer);
    this.dialogRef.close(event);
  }
  ngOnInit(): void {
  }

}
